/**
 * Route guard for the Surveys pages, which a deployment can switch off
 * (``SURVEYS_ON_THE_WEB``, reported by ``/api/me``). Switched off, a
 * bookmarked or hand-typed survey URL lands on the home page, as an admin
 * route does for a non-admin.
 */
import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useMe } from "@/auth/useMe";

export function SurveysGate({ children }: { children: ReactElement }) {
  const { data, isLoading } = useMe();

  if (isLoading) {
    return <p className="font-sans text-sm text-bw-ink-muted">Loading…</p>;
  }
  if (!data?.surveys_on_the_web) {
    return <Navigate to="/" replace />;
  }
  return children;
}
